// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3Lkdm","detailsBorder":"styles_detailsBorder__2BbMj"};